require('./tabindex');

var MODULE_NAME = 'ui.bootstrap.module.tabindex';

angular.module(MODULE_NAME, ['ui.bootstrap.tabindex']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/tabindex/index.js
// module id = 569
// module chunks = 0